import firebase from 'firebase';


const config = {
  apiKey: "AIzaSyBOwy1Rb2gQzqS3H9WQuzPV0nV8fevZNgc",
  authDomain: "tutorm-db33prg.firebaseapp.com",
  databaseURL: "https://tutorm-db33prg.firebaseio.com",
  projectId: "tutorm-db33prg",
  storageBucket: "tutorm-db33prg.appspot.com",
  messagingSenderId: "64100729065"
  };

const fbejska = require('firebase/app');
const fire = fbejska.initializeApp(config);

export default fire;



// WEBPACK FOOTER //
// ./src/Firebase.js